import React from "react";

import DownloadButton from "components/DownloadButton";

const PropertyDocuments = ({ className = "", propertyDocumentsData = [], showTextLength = 34 }) => (
    <div className={`property-documents ${className}`}>
        {propertyDocumentsData && propertyDocumentsData.length
            ? propertyDocumentsData.map(({ className, title, path, description }, index) => {
                  if (!path) {
                      return null;
                  }
                  return (
                      <DownloadButton
                          showTextLength={showTextLength}
                          key={index}
                          className={className}
                          fileURL={path}
                          title={title}
                          description={description}
                      />
                  );
              })
            : null}
    </div>
);

export default PropertyDocuments;
